import React from "react";

function ProtectedShell({ children }) {
  return (
    <div className="min-h-screen bg-gray-100">
      <div>{children}</div>
    </div>
  );
}

export default ProtectedShell;